import type {
  OrderClientView, OrderClientListItem, PatchOrderHeader, AddItemRequest,
} from '@swiftpay/shared';
import { apiFetch } from './client.js';

export const clientOrdersApi = {
  list: () => apiFetch<OrderClientListItem[]>('/api/orders'),
  detail: (id: string) => apiFetch<OrderClientView>(`/api/orders/${id}`),
  create: () => apiFetch<{ id: string; tmcNumber: string }>('/api/orders', { method: 'POST' }),
  patch: (id: string, body: Partial<PatchOrderHeader>, ifMatch?: string) =>
    apiFetch<{ ok: true; updatedAt: string }>(`/api/orders/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
      headers: ifMatch ? { 'If-Match': ifMatch } : {},
    }),
  addItem: (id: string, body: AddItemRequest) =>
    apiFetch<{ id: string; position: number }>(`/api/orders/${id}/items`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  removeItem: (id: string, itemId: string) =>
    apiFetch<{ ok: true }>(`/api/orders/${id}/items/${itemId}`, { method: 'DELETE' }),
  submitToManager: (id: string) =>
    apiFetch<{ ok: true; status: string }>(`/api/orders/${id}/submit-to-manager`, { method: 'POST' }),
  cancelByClient: (id: string) =>
    apiFetch<{ ok: true; status: string }>(`/api/orders/${id}/cancel-by-client`, { method: 'POST' }),
  withdrawByClient: (id: string) =>
    apiFetch<{ ok: true; status: string }>(`/api/orders/${id}/withdraw-by-client`, { method: 'POST' }),
};
